var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maintenance icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Misc/Hammer/96px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hammer",
    transform: "translate(10.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7600924,20.5945659 C71.7057428,22.0590712 67.8867168,21.6401624 66.1120517,20.1488469 C64.1742374,18.5201294 64.4472628,14.6460604 65.4494657,12.065582 C62.6126653,8.38923808 59.1698816,3.84156376 54.3586414,1.9279882 C47.8393277,-0.665895311 41.0736253,-0.686002936 35.2035793,2.13241571 L35.8994611,7.74579411 C39.4121659,7.50450262 41.8860423,7.53466406 44.7228428,8.33226648 C48.6117898,9.43148326 51.1123029,13.1312861 49.4142181,17.6454477 C48.7815983,19.3277856 47.8326686,21.0302311 46.6107135,22.3204703 C42.6418565,26.489451 38.0370502,30.859508 33.951658,34.9111943 C31.9339337,33.2053975 29.1404178,34.3649372 28.3313303,35.1524858 C21.2526475,42.0058343 8.21069054,54.7004477 1.122019,61.550445 C-0.516133369,63.1288934 -0.306369955,65.5015931 1.39837397,67.3481432 C3.60588418,69.7443018 6.45600294,72.8140657 8.75008217,75.1230912 C10.2517218,76.6345143 12.9553392,75.9877191 14.2105901,74.72429 C20.6266869,68.2697427 34.4610834,54.46921 40.9237943,48.0649317 C42.6285382,46.3758913 43.0813608,43.7619002 41.3499803,41.8181632 C45.2489161,37.7497206 49.0313167,33.8655978 52.8070581,29.9781238 C55.0079092,27.7126648 58.8069576,26.0940011 60.7281241,27.5585064 C62.8490653,29.1771701 62.0033525,32.4547129 60.8846143,34.498988 C61.8202257,35.3602646 62.8590541,36.2986203 63.7846767,37.260435 C65.1564629,38.6780225 67.5437703,38.6746713 68.942193,37.2470299 C71.2162948,34.9178968 74.2961544,31.663813 76.5968928,29.2073316 C78.4880931,27.1865154 78.3948649,24.1569667 76.753383,22.960563 C75.8943519,22.3305241 75.1485264,21.6569187 73.7600924,20.5945659 Z",
    id: "Stroke-3",
    stroke: "#001823",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,35 L42,43",
    id: "Stroke-7",
    stroke: "#001823",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1146413,69.5683627 L6.38827851,65.6330565 C5.85876006,65.07183 5.8719158,64.1678186 6.42116786,63.6200347 L29.9173159,40.3980309 C30.466568,39.8536076 31.3545803,39.8704108 31.8873877,40.4316373 L35.6104615,44.3669435 C36.1432689,44.92817 36.1268243,45.8355421 35.5775722,46.3799653 L12.0847131,69.6019691 C11.5321721,70.1463924 10.6474487,70.1295892 10.1146413,69.5683627",
    id: "Fill-9",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7866667,27.7983333 C24.7866667,27.7983333 18.7566667,23.195 6.53333333,20.725",
    id: "Stroke-13",
    stroke: "#001823",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.045825,31.4515 C5.045825,31.4515 10.990075,32.631 15.189075,36.271",
    id: "Stroke-17",
    stroke: "#001823",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85033333,9.6315 C6.85033333,9.6315 24.3536667,12.82625 34.2736667,20.922",
    id: "Stroke-21",
    stroke: "#001823",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6303,11.5993333 C56.6303,11.5993333 58.5693,14.8426667 57.0608,19.436",
    id: "Stroke-25",
    stroke: "#001823",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,21 L67.6626667,28.1253333",
    id: "Stroke-29",
    stroke: "#001823",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.3ccfd594ef5b8864523958addd4dc5aa.svg";
export { ForwardRef as ReactComponent };